import { BDPModule } from 'src/app/modules/bdp/bdp.module';
import { ConfigBDP } from 'src/app/modules/bdp/config/config';

export const facilityModule = BDPModule;

export const configFacility = ConfigBDP;
